// // src/utils/cropUtils.js
// // ✅ Full updated getCroppedImg — PNG format, 2x resolution, no compression
// export const getCroppedImg = (imageSrc, pixelCrop, targetW, targetH) =>
//   new Promise((resolve, reject) => {
//     const image = new Image();
//     image.crossOrigin = "anonymous";

//     image.onload = () => {
//       // ✅ 2x pixel density for retina screens
//       const SCALE  = 2;
//       const canvas = document.createElement("canvas");
//       canvas.width  = targetW * SCALE;
//       canvas.height = targetH * SCALE;

//       const ctx = canvas.getContext("2d");

//       // ✅ Best quality rendering
//       ctx.imageSmoothingEnabled  = true;
//       ctx.imageSmoothingQuality  = "high";

//       ctx.drawImage(
//         image,
//         pixelCrop.x,
//         pixelCrop.y,
//         pixelCrop.width,
//         pixelCrop.height,
//         0,
//         0,
//         targetW * SCALE,  // draw at 2x
//         targetH * SCALE,
//       );

//       // ✅ PNG = zero compression, lossless quality
//       canvas.toBlob(
//         (blob) => {
//           if (!blob) { reject(new Error("Canvas is empty")); return; }
//           resolve(blob);
//         },
//         "image/png",   // ✅ was "image/jpeg" — PNG has NO quality loss
//       );
//     };

//     image.onerror = () => reject(new Error("Failed to load image"));
//     image.src = imageSrc;
//   });

// src/utils/cropUtils.js
export const getCroppedImg = (imageSrc, pixelCrop, targetW = 354, targetH = 145) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";

    image.onload = () => {
      try {
        const dpr =
          typeof window !== "undefined" && window.devicePixelRatio
            ? Math.max(2, Math.min(window.devicePixelRatio, 3))
            : 2;

        const cropX = Math.round(pixelCrop.x);
        const cropY = Math.round(pixelCrop.y);
        const cropW = Math.round(pixelCrop.width);
        const cropH = Math.round(pixelCrop.height);

        const cropCanvas = document.createElement("canvas");
        cropCanvas.width = cropW;
        cropCanvas.height = cropH;

        const cropCtx = cropCanvas.getContext("2d");
        cropCtx.imageSmoothingEnabled = true;
        cropCtx.imageSmoothingQuality = "high";

        cropCtx.drawImage(
          image,
          cropX,
          cropY,
          cropW,
          cropH,
          0,
          0,
          cropW,
          cropH
        );

        let currentCanvas = cropCanvas;
        let currentW = cropW;
        let currentH = cropH;

        const finalW = Math.round(targetW * dpr);
        const finalH = Math.round(targetH * dpr);

        while (currentW * 0.5 > finalW && currentH * 0.5 > finalH) {
          const tmpCanvas = document.createElement("canvas");
          const nextW = Math.max(finalW, Math.round(currentW * 0.5));
          const nextH = Math.max(finalH, Math.round(currentH * 0.5));

          tmpCanvas.width = nextW;
          tmpCanvas.height = nextH;

          const tmpCtx = tmpCanvas.getContext("2d");
          tmpCtx.imageSmoothingEnabled = true;
          tmpCtx.imageSmoothingQuality = "high";
          tmpCtx.drawImage(currentCanvas, 0, 0, currentW, currentH, 0, 0, nextW, nextH);

          currentCanvas = tmpCanvas;
          currentW = nextW;
          currentH = nextH;
        }

        const finalCanvas = document.createElement("canvas");
        finalCanvas.width = finalW;
        finalCanvas.height = finalH;
        finalCanvas.style.width = `${targetW}px`;
        finalCanvas.style.height = `${targetH}px`;

        const finalCtx = finalCanvas.getContext("2d");
        finalCtx.imageSmoothingEnabled = true;
        finalCtx.imageSmoothingQuality = "high";
        finalCtx.drawImage(currentCanvas, 0, 0, currentW, currentH, 0, 0, finalW, finalH);

        finalCanvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Canvas is empty"));
              return;
            }
            resolve(blob);
          },
          "image/png"
        );
      } catch (err) {
        reject(err);
      }
    };

    image.onerror = () => reject(new Error("Failed to load image"));
    image.src = imageSrc;
  });